import * as React from 'react';
export const commonpaperSvg = React.forwardRef(function commonpaperSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#17343E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F19E38',
      d: 'M16.709 16.89v8.416a18.18 18.18 0 0 1-1.385 0v-6.67l-3.518 5.694c-.406-.223-.8-.461-1.186-.716l3.453-5.589-5.835 3.13a16.853 16.853 0 0 1-.679-1.208l5.702-3.058H6.71v-1.384h6.157l-5.647-2.61c.17-.43.356-.851.559-1.267l6.305 2.914L10.21 8.71c.372-.276.752-.535 1.145-.78l3.968 5.972V6.71c.463-.018.923-.018 1.386 0v8.795H28a11.998 11.998 0 0 0-3.737-8.215 12.008 12.008 0 0 0-20.261 8.513 11.997 11.997 0 0 0 3.256 8.416 12.007 12.007 0 0 0 20.72-7.33h-11.27Z',
    }),
  );
});
commonpaperSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var commonpaper = {
  category: 'brand',
  colorable: false,
  name: 'commonpaper',
  svg: commonpaperSvg,
};
